import {IntlErrorCode} from 'next-intl';

/**
 * Fail fast on missing translations (dev, tests, and production build prerender).
 */
export function onIntlError(error) {
  if (
    error.code === IntlErrorCode.MISSING_MESSAGE ||
    error.code === IntlErrorCode.INSUFFICIENT_PATH
  ) {
    throw error;
  }

  console.error(error);
}
